import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogPortal,
  DialogTitle,
} from '@/components/ui/dialog'
import { T, useTranslate } from '@tolgee/react'

type SetState<T> = (value: T | ((prev: T) => T)) => void

export function DeleteScheduleDialog({
  open,
  onOpenChange,
  scheduleName,
  onConfirm,
  isLoading = false,
}: Readonly<{
  open: boolean
  onOpenChange: SetState<boolean>
  scheduleName?: string | null
  onConfirm: () => void
  isLoading?: boolean
}>) {
  const { t } = useTranslate()

  const handleConfirm = () => {
    onConfirm()
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogPortal>
        <DialogContent className='gap-2'>
          <DialogTitle className='text-2xl'>
            <T keyName='schedule.deleteDialog.title' />
          </DialogTitle>
          <DialogDescription>
            <T keyName='schedule.deleteDialog.message' />
            {scheduleName ? <span className='font-bold'>{scheduleName}</span> : 'this schedule'}?
          </DialogDescription>
          <DialogFooter>
            <DialogClose asChild>
              <Button
                disabled={isLoading}
                variant='mango-outline'
                title={t('shared.cancelDialog.a11y')}
              >
                <T keyName='shared.cancelDialog.title' />
              </Button>
            </DialogClose>
            <Button
              type='submit'
              className='uppercase'
              loading={isLoading}
              onClick={handleConfirm}
              title={t('schedule.deleteDialog.delete.a11y')}
            >
              <T keyName='schedule.deleteDialog.delete.title' />
            </Button>
          </DialogFooter>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  )
}
